export default __webpack_public_path__ + "static/media/affiche2012.a3e149ac.png";